// dispatchers
import { respin, userConfigDispatcher } from '@aceroll/core';

import { StateController, dispatcher, serverData } from "@aceroll/core";

class ReSpinStartController extends StateController {
    slotMachine = null;

    constructor() {
        super("respin");
    }

    async onStart() {
        if (!respin.isStarted()) {
            respin.start();
        }

        const { slotMachine } = dispatcher.app.layout;

        serverData.featureCount['respin'] -= 1;

        userConfigDispatcher.setMode('lightingTurbo');

        slotMachine.spin();

        await slotMachine.updateRespinCounter(serverData.featureCount['respin']);

        this.stop();

    }

    onStop() {

    }
}

export default ReSpinStartController;